export const getValidUrl = path =>
  path.startsWith("http") ? path : `//${path}`;
